;(function (module) {
    'use strict';

    class Store {
        constructor(localStorageService) {
            this.localStorageService = localStorageService;
            this.store = window.store = {
                currentUser: {},
                currentAccount: {},

                // globals
                users: [],
                accounts: [],
                subAccounts: [],

                // can be a sub account specific
                apps: [],
                appTemplates: [],
                groups: [],
                displays: [],
                integrations: [],
                files: [],
                playlists: [],
                schedules: [],
                vendors: [],
            };
        }

        // we want to wipe the data models when switching between the sub accounts
        wipeSubAccountModels() {
            ['apps', 'appTemplates', 'groups', 'displays', 'integrations', 'files', 'playlists'].forEach((modelName) => {
                this.deleteMultiModelData(modelName);
            });
        }

        setCurrentAccount(data) {
            this.store.currentAccount = _.cloneDeep(data);
            return this.store.currentAccount;
        }

        getCurrentAccount() {
            return this.store.currentAccount;
        }

        getCurrentAccountId() {
            return _.get(this, 'store.currentAccount.id');
        }

        setFoldedMenu(folded) {
            console.log('setFoldedMenu', folded);
            const accountId = _.get(this, 'store.currentAccount.id');
            this.localStorageService.set(`accountId_${accountId}_foldedMenu`, folded);
        }

        getFoldedMenu() {
            const accountId = _.get(this, 'store.currentAccount.id');
            return this.localStorageService.get(`accountId_${accountId}_foldedMenu`);
        }

        setCurrentSubAccountId(id) {
            const subAccountId = (id) ? Number(id) : null;
            const accountId = _.get(this, 'store.currentAccount.id');
            this.localStorageService.set(`accountId_${accountId}_subAccountId`, subAccountId);
        }

        getCurrentSubAccountId() {
            const accountId = _.get(this, 'store.currentAccount.id');
            return this.localStorageService.get(`accountId_${accountId}_subAccountId`);
        }

        setCurrentUser(data) {
            this.store.currentUser = _.cloneDeep(data);
            return this.store.currentUser;
        }

        getCurrentUser() {
            return this.store.currentUser;
        }

        setMultiModelData(model, data) {
            this.store[model] = data;
            return this.store[model];
        }

        getMultiModelData(model) {
            return this.store[model];
        }

        deleteMultiModelData(model) {
            this.store[model] = [];
        }

        getFiles() {
            return this.store.files;
        }

        getSingleModelData(model, id) {
            const index = _.findIndex(this.store[model], function (item) {
                return Number(id) === Number(item.id);
            });

            if (index >= 0) {
                return this.store[model][index];
            } else {
                return undefined;
            }
        }

        setSingleModelData(model, id, data) {

            const index = _.findIndex(this.store[model], function (item) {
                return Number(id) === Number(item.id);
            });

            // if exist, update
            // otherwise, push into
            if (index >= 0) {
                this.store[model][index] = data;
                return this.store[model][index];
            } else {
                this.store[model].push(data);
                return this.store[model][this.store[model].length - 1];
            }

        }

        removeSingleModelData(model, id) {
            return _.remove(this.store[model], function (item) {
                return id == item.id;
            });
        }

    }

    module.service('Store', Store);

})(angular.module('rocket.components'));
